export const MARK_CODE = 'code';
export const MARK_EM = 'em';
export const MARK_FONT_SIZE = 'mark-font-size';
export const MARK_FONT_TYPE = 'mark-font-type';
export const MARK_LINK = 'link';
export const MARK_NO_BREAK = 'mark-no-break';
export const MARK_STRIKE = 'strike';
export const MARK_STRONG = 'strong';
export const MARK_SUPER = 'super';
export const MARK_TEXT_COLOR = 'mark-text-color';
export const MARK_TEXT_HIGHLIGHT = 'mark-text-highlight';
export const MARK_TEXT_SELECTION = 'mark-text-selection';
export const MARK_UNDERLINE = 'underline';
export const MARK_SPACER = 'spacer';
export const HEADING_ONE = 'heading-one'
export const MARK_SPAN = 'mark-span'
